import { VideoError } from '@videos/errors/video-error';
import VideoErrorInterface from '@videos/errors/video-error.interface';

export default class VideoPrivateError extends VideoError implements VideoErrorInterface {
    readonly code = 'private-access';
}
